<template>
  <div class="chat-item__inr">
    <div class="chat-item__txt">
      <div class="chat-item__txt__inr">
        <div class="sp sp-3balls"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WritingAnimation'
}
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/import/var";
  .chat-item {
    &__inr {
      min-height: 5rem;
    }
    &__txt {
      &__inr {
        display: flex;
        width: 30%;
        justify-content: center;
        align-items: center;

        &:before, &:after {
          border-radius: 50%;
          background-color: #000;
          width: 8px;
          height: 8px;
          transform-origin: center center;
          display: inline-block;
          @include mq(md) {
            transform: scale(0.8);
          }
        }
        &:before, &:after {
          content: '';
          position: relative;
          opacity: 0.25;
          margin: 0 8px;
          @include mq(sm) {
            margin: 0 4px;
          }
        }
        &:before {
          -webkit-animation: spScaleAlphaBefore 1s infinite linear;
          animation: spScaleAlphaBefore 1s infinite linear;
        }
        &:after {
          -webkit-animation: spScaleAlphaAfter 1s infinite linear;
          animation: spScaleAlphaAfter 1s infinite linear;
        }
      }
    }
  }
  .sp {
    width: 32px;
    height: 32px;
    clear: both;
    &-3balls {
      @include mq(md) {
        transform: scale(0.8);
      }
      border-radius: 50%;
      background-color: #000;
      width: 8px;
      height: 8px;
      transform-origin: center center;
      display: inline-block;
      position: relative;
      background-color: black;
      opacity: 1;
      -webkit-animation: spScaleAlpha 1s infinite linear;
      animation: spScaleAlpha 1s infinite linear;
    }
  }
  @-webkit-keyframes spScaleAlpha {
    0% {
      opacity: 1;
    }
    33% {
      opacity: 0.25;
    }
    66% {
      opacity: 0.25;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes spScaleAlpha {
    0% {
      opacity: 1;
    }
    33% {
      opacity: 0.25;
    }
    66% {
      opacity: 0.25;
    }
    100% {
      opacity: 1;
    }
  }
  @-webkit-keyframes spScaleAlphaBefore {
    0% {
      opacity: 0.25;
    }
    33% {
      opacity: 1;
    }
    66% {
      opacity: 0.25;
    }
  }
  @keyframes spScaleAlphaBefore {
    0% {
      opacity: 0.25;
    }
    33% {
      opacity: 1;
    }
    66% {
      opacity: 0.25;
    }
  }
  @-webkit-keyframes spScaleAlphaAfter {
    33% {
      opacity: 0.25;
    }
    66% {
      opacity: 1;
    }
    100% {
      opacity: 0.25;
    }
  }
  @keyframes spScaleAlphaAfter {
    33% {
      opacity: 0.25;
    }
    66% {
      opacity: 1;
    }
    100% {
      opacity: 0.25;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/animations/WritingAnimation.vue